import { Cube } from '../types'

export default function (cube: Cube & any) {
//  const { cubeNumber, ...data } = cube
  return cube;
//  return data
}
